export enum Trafficlight {
  GREEN = 'available',
  RED = 'not available',
  ORANGE = 'reserved',
}
